<template>
  <b-modal has-modal-card trap-focus aria-role="dialog" aria-modal :active="this.isActive" :on-cancel="closeModal">
    <div class="modal-card">
      <section class="modal-card-body has-background-white">
        <h3 class="title is-size-3">{{ $t('mandatory.tos-abrev') }} & {{ $t('mandatory.data-protection') }}</h3>
        <div class="field">
          <b-checkbox @input="tosTrigger">
            {{ $t('payment.consent.agb_accept_1') }}
            <a href="/agb" title="Allgemeine Geschäftsbedingungen" target="_blank">{{ $t('payment.consent.agb_accept_2') }}</a> {{ $t('payment.consent.agb_accept_3') }} <a href="/datenschutz" title="Datenschutzbestimmungen" target="_blank">{{ $t('payment.consent.agb_accept_4') }}</a>
            {{ $t('payment.consent.agb_accept_5') }}
            <!-- VERSICHERUNG START -->
            <!-- <span
          >Des Wei­te­ren habe Ich die <a href="https://secure-fbt.hmrv.de/rda-web/servlet/DokumentAdapter?dokumentTyp=PIB&uuid=b03cf9e8-90e2-47a1-abf8-f37133e81e53&groupId=31253" target="_blank" rel="noopener">Tarifbeschreibung</a> und
          <a target="_blank" rel="noopener" href="https://secure-fbt.hmrv.de/rda-web/servlet/DokumentAdapter?dokumentTyp=AVB&uuidGroup=40a45efb-7cc9-4d14-bac4-7804b61d53a0/31253">Versicherungsbedingungen</a> der HanseMerkur Reiseversicherung AG gelesen und akzeptiere diese.has-background-white
        </span> -->
            <!-- VERSICHERUNG END -->
          </b-checkbox>
        </div>
        <AdacOptin />
      </section>
      <footer class="modal-card-foot">
        <b-button :disabled="!isTosAccepted" @click="closeModal" class="is-fullwidth">{{ $t('general.next') }}</b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import AdacOptin from './AdacOptin'

export default {
  name: 'OptinModal',
  components: {
    AdacOptin,
  },
  props: {
    isActive: {type: Boolean, default: false},
  },
  computed: {},
  data() {
    return {
      isModalActive: this.isActive,
      isTosAccepted: false,
    }
  },
  mounted() {},
  methods: {
    closeModal() {
      this.$emit('accepted', this.isTosAccepted)
    },
    tosTrigger(val) {
      this.isTosAccepted = val
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-card {
  width: auto;
  max-width: 520px;
  margin: 0 auto !important;
  padding-left: 1rem;
  padding-right: 1rem;

  @media screen and (min-width: 768px) {
    width: 100%;
  }
}
.card-content {
  & > .title {
    height: 55px;
  }

  ul {
    list-style: none;
  }
}
</style>
